import React, {useState} from "react";
import {Bars} from "react-loader-spinner";
import {useHistory, useParams} from "react-router-dom";
import moment from "moment";

import Backdrop from "@material-ui/core/Backdrop";

import {ApolloAxios, ApiResponse, getResultType, isSuccessApi} from "../../atom/Apollo_ApiRequest3";
import {
  APOLLO_GROUP_OPERATOR,
  APOLLO_PROFILE_SYSTEM_ADMIN,
  ApolloPageUsagePermission
} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";
import {
  adclienticonsapollo_path,
  apollo_ad_client_icon_path,
} from "../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {
  apollo_useStyles,
  options_state,
  valueToOption,
} from "../../atom/Apollo_styles";

import {IsAdClientIconSelectableMenu} from "../../molecule/Apollo_SelectMenu";

import GenericTemplate from "../../templates/GenericTemplate";

import {AdClientIcon, AdClientIconInfo} from "./AccountModel"
import AdClientIconFormApollo, {AdClientIconProcessType} from "./AdClientIconFormApollo";

const AdClientIconCreateApollo: React.FC = () => {

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 20,
    breadId: 2,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const initAdClientIconInfo: AdClientIconInfo = {
    adClientIconId: 0,
    adClientIconName: "",
    imageUrl: "",
    status: 0,
    approval: 0,
    denialReason: 0,
    denialReasonDetail: "",
  }

  const history = useHistory();
  const classes = apollo_useStyles();
  const {accountgroupid, accountid} = useParams<{
    accountgroupid: string,
    accountid: string
  }>();
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {state} = React.useContext(ApolloContext);

  const [adClientIcon, setAdClientIcon] = React.useState<AdClientIcon>({
    attachment: "",
  })

  const [adClientIconFlg, setAdClientIconFlg] = React.useState(false);
  const [progress, setProgress] = useState(false);
  const adClientIconInfo = React.useRef<AdClientIconInfo>(initAdClientIconInfo);
  const resultData = React.useRef<any>(null);
  const resultApi = React.useRef(-1);

  // 登録
  const handleSave = async(formData: any) => {
    let isSuccess = false;
    setProgress(true);

    // 操作ログ出力(登録)
    adClientIconInfo.current.status = formData.status
    adClientIconInfo.current.adClientIconName = adClientIcon.attachment.name + ""
    resultApi.current = 0;
    writeLog();

    const url = `${apollo_ad_client_icon_path}/${accountid}`;
    const form = new FormData();
    form.append('adClientIcon', adClientIcon.attachment);
    form.append('status', String(formData.status));
    await ApolloAxios.post(
      url,
      form,
      {},
    ).then(response => {
      const res: ApiResponse = response.data;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: getResultType(res.resultCode),
          message: res.message,
        }
      });

      if (isSuccessApi(res.resultCode)) {
        // 操作ログ(成功)
        resultData.current = res.result;
        resultApi.current = 1;
        isSuccess = true;
      } else {
        // 操作ログ(失敗)
        resultApi.current = 9;
      }
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
    });

    setProgress(false);
    if (isSuccess) {
      history.push(`${adclienticonsapollo_path}${accountgroupid}/${accountid}`);
    }
  }

  const handleGoBack = () => {
    setmsg({
      type: "setMessage",
      payload: {
        ...data,
        open: false,
        type: "",
        message: "",
      }
    });
    history.push(`${adclienticonsapollo_path}${accountgroupid}/${accountid}`);
  }

  // 操作ログ出力
  const writeLog = () => {
    if (resultApi.current < 0) return;

    const itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: "",
        afterValue: valueToOption(adClientIconInfo.current.status, options_state).label + "",
      },
      {
        key: "アップロードファイル",
        beforeValue: "",
        afterValue: adClientIconInfo.current.adClientIconName + "",
      },
    ]

    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: resultApi.current === 0 ? "execute" : "result",
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "",
      campaignName: "",
      adGroupID: "",
      adGroupName: "",
      menu: "",
      displayName: "広告主アイコン新規作成画面",
      category: "広告主アイコン",
      actionType: "アップロード",
      targetID: resultApi.current === 0 ? "" : resultData.current ? resultData.current.adClientIconId + "" : "",
      targetName: resultApi.current === 0 ? "" : resultData.current ? resultData.current.adClientIconName + "" : "",
      itemList: itemList,
    }

    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <IsAdClientIconSelectableMenu
        adClientIconFlg={adClientIconFlg}
        setAdClientIconFlg={setAdClientIconFlg}
        isDisplayErrMsg={true}
      >
        <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
          <Backdrop className={classes.backdrop2} open={progress}>
            <Bars color="#00BFFF" height={80} width={80}/>
          </Backdrop>
          <ApolloBreadcrumbs2 data={breadcrumbsData}/>
          <AdClientIconFormApollo
            accountId={state.current.accountId}
            accountName={state.current.accountName}
            adClientIconState={{
              adClientIcon: adClientIcon,
              setAdClientIcon: setAdClientIcon,
            }}
            submitAction={handleSave}
            goBackAction={handleGoBack}
            processType={AdClientIconProcessType.create}
          />
        </ApolloPageUsagePermission>
      </IsAdClientIconSelectableMenu>
    </GenericTemplate>
  );
}
export default AdClientIconCreateApollo;
